import { useCallback } from 'react';

import {
  Feature,
  HoldsAndCheckoutsTab,
  holdsAndCheckoutsTabs,
  Route,
} from '@app/constants';

import { useFeatureFlag } from './useFeatureFlag';

export type SelectConfiguredOption = <RequestsOption, HoldsOption>(
  requestAndLoansOption: RequestsOption,
  holdsAndCheckoutsOption: HoldsOption
) => RequestsOption | HoldsOption;

export const useHoldsAndCheckoutsPageConfig = () => {
  const { config } = useFeatureFlag({
    name: Feature.holdsAndCheckouts,
  });

  const selectConfiguredOption: SelectConfiguredOption = useCallback(
    (requestAndLoansOption, holdsAndCheckoutsOption) =>
      config.isRequestsAndLoans
        ? requestAndLoansOption
        : holdsAndCheckoutsOption,
    [config.isRequestsAndLoans]
  );

  const parentRoute = selectConfiguredOption(
    Route.requestsAndLoans,
    Route.holdsAndCheckouts
  );

  const getTabRoute = useCallback(
    (tabName: HoldsAndCheckoutsTab): Route => {
      const tabRoutes = config.isRequestsAndLoans
        ? {
            [holdsAndCheckoutsTabs.holds]: Route.requests,
            [holdsAndCheckoutsTabs.checkouts]: Route.loans,
            [holdsAndCheckoutsTabs.fees]: Route.fees,
          }
        : Route;
      const tabRoute = tabRoutes[tabName];

      return `${parentRoute}${tabRoute}` as Route;
    },
    [parentRoute, config.isRequestsAndLoans]
  );

  return {
    holdsAndCheckoutsRoute: parentRoute,
    selectConfiguredOption,
    getTabRoute,
  };
};
